import { NgModule, InjectionToken, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NotificationsModule } from '@content-platform/web-angular-shared-ui-notifications';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { fromError } from './reducers';
import { ErrorEffects } from './effects/error.effects';
import { ErrorContainerComponent } from './error-container/error-container.component';
import { ErrorItemComponent } from './error-item/error-item.component';
import { GenericErrorGuard } from './guards/generic-error.guard';
import { WebAngularSharedUtilErrorHandlingConfig } from './error-handling-config';
import { ErrorDispatchService } from './error-dispatch.service';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';
import { REPORT_PARAM_TRANSFORMERS } from './models';
import { IssueReportingService } from './issue-reporting.service';
import { AcquireTokenErrorComponent } from './acquire-token-error/acquire-token-error.component';
import { MatDividerModule } from '@angular/material/divider';
import { MaintenancePageComponent } from './maintenance/maintenance-page.component';
import * as i0 from "@angular/core";
/**
 * This factory allows me to initiate the transformer classes, and provides around this issue:
 *   Function expressions are not supported in decorators
 * This is why I am passing in the un initiated classes through the Injection token below.
 * The factory is only provided in the forRoot, so that would have be called in the main app.
 */
export const INITIAL_REPORT_TRANSFORMERS_CLASS = new InjectionToken('initial-report-transformer-class');
export function classFactory(injector, paramTransformers) {
    return paramTransformers
        .filter((paramTransformer) => !!paramTransformer)
        .map((paramTransformerClass) => new paramTransformerClass(injector));
}
const MATERIAL_MODULES = [
    MatLegacyCardModule,
    MatExpansionModule,
    MatIconModule,
    MatLegacyButtonModule,
    MatDividerModule
];
export class WebAngularSharedUtilErrorHandlingModule {
    static forRoot(options = {}, paramTransformer) {
        return {
            ngModule: WebAngularSharedUtilErrorHandlingModule,
            providers: [
                { provide: WebAngularSharedUtilErrorHandlingConfig, useValue: options },
                { provide: INITIAL_REPORT_TRANSFORMERS_CLASS, multi: true, useValue: paramTransformer },
                {
                    provide: REPORT_PARAM_TRANSFORMERS,
                    useFactory: classFactory,
                    deps: [Injector, INITIAL_REPORT_TRANSFORMERS_CLASS]
                }
            ]
        };
    }
    static withExtraParams(paramTransformer) {
        return {
            ngModule: WebAngularSharedUtilErrorHandlingModule,
            providers: [
                { provide: INITIAL_REPORT_TRANSFORMERS_CLASS, multi: true, useValue: paramTransformer }
            ]
        };
    }
    static { this.ɵfac = function WebAngularSharedUtilErrorHandlingModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WebAngularSharedUtilErrorHandlingModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: WebAngularSharedUtilErrorHandlingModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            GenericErrorGuard,
            { provide: WebAngularSharedUtilErrorHandlingConfig, useValue: {} },
            ErrorDispatchService,
            IssueReportingService
        ], imports: [CommonModule,
            RouterModule,
            StoreModule.forFeature('error', fromError.reducer),
            EffectsModule.forFeature([ErrorEffects]),
            NotificationsModule,
            DevelopmentModule,
            LoggingModule, MATERIAL_MODULES] }); }
}
//# sourceMappingURL=web-angular-shared-util-error-handling.module.js.map